module.exports = __webpack_public_path__ + "assets/img/5.77f908ec.png";